import React from 'react';

import { connect } from 'react-redux';
import * as Modules from 'components/modules';
import { getPreviews } from 'selectors';
import * as actions from 'actions';
import Preview from './Preview';

class PreviewManager extends React.Component {
  render() {
    const { previews, setPageReady } = this.props;
    return (
      <React.Fragment>
        {previews.map((preview, i) => (
          <Preview
            setPageReady={setPageReady}
            i={i}
            key={preview.id}
            {...preview}
          />
        ))}
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  previews: getPreviews(state),
});
const mapDispatch = dispatch => ({
  setPageReady: () => dispatch(actions.setPageReady()),
});

export default connect(mapState, mapDispatch)(PreviewManager);



// WEBPACK FOOTER //
// ./src/components/modules/PreviewManager/PreviewManager.js